import React from "react";

// Sacred geometry mandala rendered as SVG for crisp scaling & animation.
const Mandala = ({ size = 320, opacity = 0.85, className = "" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ opacity }}
    aria-hidden
  >
    <defs>
      <radialGradient id="mandalaGlow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#FFD700" stopOpacity="0.9" />
        <stop offset="60%" stopColor="#FF9933" stopOpacity="0.6" />
        <stop offset="100%" stopColor="#FF9933" stopOpacity="0" />
      </radialGradient>
      <linearGradient id="stroke1" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#FFD700" />
        <stop offset="100%" stopColor="#FF9933" />
      </linearGradient>
    </defs>

    <circle cx="100" cy="100" r="92" fill="url(#mandalaGlow)" opacity="0.35" />
    <circle cx="100" cy="100" r="88" stroke="url(#stroke1)" strokeWidth="0.4" opacity="0.6" />
    <circle cx="100" cy="100" r="70" stroke="#FF9933" strokeWidth="0.35" opacity="0.55" />
    <circle cx="100" cy="100" r="54" stroke="#FFD700" strokeWidth="0.35" opacity="0.7" />
    <circle cx="100" cy="100" r="34" stroke="#FF9933" strokeWidth="0.4" opacity="0.85" />
    <circle cx="100" cy="100" r="18" stroke="#FFD700" strokeWidth="0.6" opacity="0.9" />
    <circle cx="100" cy="100" r="3" fill="#FFD700" />

    {/* 12-fold petals */}
    {Array.from({ length: 12 }).map((_, i) => {
      const a = (i * 360) / 12;
      return (
        <g key={i} transform={`rotate(${a} 100 100)`}>
          <path
            d="M100 30 C 108 55 108 75 100 100 C 92 75 92 55 100 30 Z"
            stroke="url(#stroke1)"
            strokeWidth="0.35"
            fill="rgba(255,153,51,0.04)"
          />
        </g>
      );
    })}
    {/* 24 outer ticks */}
    {Array.from({ length: 24 }).map((_, i) => {
      const a = (i * 360) / 24;
      return (
        <g key={`t-${i}`} transform={`rotate(${a} 100 100)`}>
          <line x1="100" y1="8" x2="100" y2="16" stroke="#FF9933" strokeWidth="0.4" opacity="0.7" />
        </g>
      );
    })}
    {/* 8 diamonds */}
    {Array.from({ length: 8 }).map((_, i) => {
      const a = (i * 360) / 8;
      return (
        <g key={`d-${i}`} transform={`rotate(${a} 100 100)`}>
          <rect
            x="97"
            y="46"
            width="6"
            height="6"
            transform="rotate(45 100 49)"
            stroke="#FFD700"
            strokeWidth="0.3"
            fill="rgba(255,215,0,0.06)"
          />
        </g>
      );
    })}
  </svg>
);

export default Mandala;
